import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const AboutSection = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
`;

export const AboutSectionImage = styled.img`
  width: 100%;
  height: 80vh;
  object-fit: cover;
  object-position: center;
`;

export const AboutSectionTextContainer = styled.div`
  position: absolute;
  top: 35%;
  left: 50%;
  min-width: 45%;
  z-index: 3;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  padding: 20px;
  border-radius: 10px;
  max-height: 40%;

  @media (max-width: 560px) {
    min-width: 75%;
  }
`;

export const AboutSectionGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(3, 26, 65, 1) 0%,
    rgba(0, 0, 255, 0) 100%
  );
  z-index: 1;
`;

export const AboutSectionTextIntroTitle = styled.h3`
  letter-spacing: 2px;
  font-weight: lighter;
`;

export const AboutSectionTextTitle = styled.h1`
  margin-top: 20px;
`;

export const AboutSectionText = styled.p`
  margin-top: 20px;
  line-height: 1.8;
`;

export const AboutSectionCards = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  position: relative;
  top: -130px;
  z-index: 3;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  @media (max-width: 810px) {
    top: -40px;
  }
`;

export const AboutSectionCardsCard = styled.div`
  width: 33%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 36px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  min-height: 380px;

  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: opacity 1.5s ease, transform 1.5s ease, visibility 0s 1.5s;

  &.is-visible {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    transition: opacity 1.5s ease, transform 1.5s ease, visibility 0s;
  }

  &:hover {
    transform: translateY(-20px);
  }

  @media (max-width: 1350px) {
    width: 70%;
    min-height: 380px;
  }
`;

export const AboutSectionCardsCardIcon = styled(FontAwesomeIcon)`
  color: #3393f0;
  padding: 34px;
`;

export const AboutSectionCardsCardTitle = styled.h2`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const AboutSectionCardsCardText = styled.p`
  text-align: center;
  height: 100%;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const AboutSectionCardsCardReadMoreButton = styled.div`
  border: 1px solid #3393f0;
  width: 120px;
  padding: 5px;
  border-radius: 12px;
  display: inline-block;
  color: #3393f0;
  text-align: center;
  margin-top: 30px;
  cursor: pointer;
  text-decoration: none;
`;
